import { useMemo } from 'react';

// ─────────────────────────────────────────────────────────────────────────────
// Paridad F1 (H-13) — componente de presentación para .badge-unlock-* del demo
// (PlataformaPage.tsx : 436-461). El disparo real (cuándo se desbloquea un
// badge) es responsabilidad de la fase de rachas/badges (F6/F7); aquí solo se
// porta el CSS y el marcado, sin ningún estado de "escenario de demo".
// ─────────────────────────────────────────────────────────────────────────────
interface BadgeUnlockModalProps {
  icon: string;
  title: string;
  description: string;
  ctaLabel: string;
  onClose: () => void;
}

const SPARK_COUNT = 24;

export function BadgeUnlockModal({ icon, title, description, ctaLabel, onClose }: Readonly<BadgeUnlockModalProps>) {
  // Posiciones/temporización de las chispas son aleatorias por diseño (igual que el
  // demo) — no son un valor visual fijo portable a una clase CSS estática.
  const sparks = useMemo(
    () => Array.from({ length: SPARK_COUNT }, () => ({
      left: `${10 + Math.random() * 80}%`,
      top: `${10 + Math.random() * 80}%`,
      animationDelay: `${Math.random() * 0.8}s`,
      fontSize: `${10 + Math.random() * 14}px`,
    })),
    [],
  );

  return (
    <div className="badge-unlock-overlay" onClick={onClose}>
      <div className="badge-unlock-modal" onClick={e => e.stopPropagation()}>
        <button type="button" className="badge-unlock-close" onClick={onClose} aria-label="close">
          <i className="fas fa-times" aria-hidden="true" />
        </button>
        <div className="badge-unlock-sparkles">
          {sparks.map((s, i) => (
            <span key={i} className="badge-unlock-spark" style={s}>✨</span>
          ))}
        </div>
        <div className="badge-unlock-icon">{icon}</div>
        <h2 className="badge-unlock-title">{title}</h2>
        <p className="badge-unlock-desc">{description}</p>
        <button type="button" className="badge-unlock-cta" onClick={onClose}>
          <i className="fas fa-star" aria-hidden="true" /> {ctaLabel}
        </button>
      </div>
    </div>
  );
}
